/** The approved mock's glyphs (mockups/file-sharing-2026-09-25.html), verbatim paths. */
type P = { className?: string };

export const LockIcon = ({ className }: P) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinecap="round"
    className={className}
    aria-hidden
  >
    <rect x="4.5" y="9" width="11" height="8" rx="2" />
    <path d="M7 9V6.8a3 3 0 0 1 6 0V9" />
  </svg>
);
export const GlobeIcon = ({ className }: P) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    className={className}
    aria-hidden
  >
    <circle cx="10" cy="10" r="7" />
    <path d="M3 10h14M10 3c2.2 2.3 2.2 11.7 0 14M10 3c-2.2 2.3-2.2 11.7 0 14" />
  </svg>
);
export const PeopleIcon = ({ className }: P) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    className={className}
    aria-hidden
  >
    <circle cx="6" cy="6" r="2.3" />
    <path d="M2 13c.6-2.2 2.1-3.3 4-3.3s3.4 1.1 4 3.3" />
    <circle cx="11.2" cy="6.6" r="1.8" />
    <path d="M11 9.7c1.4 0 2.5.9 3 2.6" />
  </svg>
);
export const LinkIcon = ({ className }: P) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
  >
    <path d="M8.5 11.5a3.5 3.5 0 0 0 5 0l2.5-2.5a3.5 3.5 0 0 0-5-5l-.8.8M11.5 8.5a3.5 3.5 0 0 0-5 0L4 11a3.5 3.5 0 0 0 5 5l.8-.8" />
  </svg>
);
export const ChevronIcon = ({ className }: P) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    className={className}
    aria-hidden
  >
    <path d="M4 6l4 4 4-4" />
  </svg>
);
